import React from 'react';
import CheckCalendarContainer from '../../organisms/hotel/checkCalendarContainer';
import CheckListPopupContainer from '../../organisms/common/checkListPopupContainer';
import CrawlPopupContainer from '../../organisms/common/crawlPopupContainer';
import CrawlFacilityCalendarContainer from '../../organisms/hotel/crawlFacilityCalendarContainer';
import { HeaderContainer } from '../../organisms/common/crawlHeaderContainer';
import { MembershipFooterContainer } from '../../organisms/common/membershipFooterContainer';
import MembershipPopupContainer from '../../organisms/common/membershipPopupContainer';
import MembershipCrawlSearchContainer from '../../organisms/hotel/membershipCrawlSearchContainer';
import MembershipReservationPopupContainer from '../../organisms/common/membershipReservationPopupContainer';
import MembershipCancelPopup from '../../organisms/common/membershipCancelPopup';
import { CrawlLoginCheck } from '../../../util/crawlLoginCheck';
import CrawlSenyuubiPopupContainer from '../../organisms/common/crawlSenyuubiPopupContainer';
import RoomDetailPopupContainer from '../../organisms/hotel/roomDetailPopupContainer';
import RestaurantVacancyPopupContainer from '../../organisms/common/restaurantVacancyPopupContainer';
import { DescriptionHomeFlContainer } from '../../organisms/common/descriptionHomeFlContainer';

class MembershipCrawlSearchTemplate extends React.Component {

  render() {
    return (
      <>
        <CrawlLoginCheck/>
        <HeaderContainer
          Label categoryLabel1={"ホテル予約"}
          categoryLabel2={"CRAWL"}
          bookedConfirmLabel={"＞予約内容の確認・変更・キャンセルはこちら"}
          onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
          onClickOpenSenyuubiWindow={this.props.onClickOpenSenyuubiWindow}
          onClickOpenCrawlWindow={this.props.onClickOpenCrawlWindow}
        />
        <CheckCalendarContainer
          state={this.props.state}
          onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
          checkInFlg={this.props.state.checkInFlg}
          checkOutFlg={this.props.state.checkOutFlg}
        />
        <CrawlFacilityCalendarContainer
          state={this.props.state}
          onClickOpenFacilityCalendarWindow={this.props.onClickOpenFacilityCalendarWindow}
          facilityCalendarFlg={this.props.state.facilityCalendarFlg}
          onClickCalendarMove={this.props.onClickCalendarMove}
          onClickCloseFacilityCalendarWindow={this.props.onClickCloseFacilityCalendarWindow}
          onClickOpenCrawlWindow={this.props.onClickOpenCrawlWindow}
        />
        <CheckListPopupContainer
          state={this.props.state}
          onClickOpenCheckListWindow={this.props.onClickOpenCheckListWindow}
        />
        <CrawlPopupContainer
          state={this.props.state}
          onClickOpenCrawlWindow={this.props.onClickOpenCrawlWindow}
          onClickClosePopupWindow={this.props.onClickClosePopupWindow}
          onClickOpenSenyuubiWindow={this.props.onClickOpenSenyuubiWindow}
        />
        <RoomDetailPopupContainer
          state={this.props.state}
          onClickCloseRoomDetailPopup={this.props.onClickCloseRoomDetailPopup}
        />
        <CrawlSenyuubiPopupContainer
          state={this.props.state}
          onClickOpenDescriptionHomeFlWindow={this.props.onClickOpenDescriptionHomeFlWindow}
          onClickCloseSenyuubiPopupWindow={this.props.onClickCloseSenyuubiPopupWindow}
        />
        <DescriptionHomeFlContainer
          state={this.props.state}
          onClickCloseDescriptionHomeFlWindow={this.props.onClickCloseDescriptionHomeFlWindow}
        />
        <RestaurantVacancyPopupContainer
          state={this.props.state}
          onClickCloseRestaurantVacancyPopup={this.props.onClickCloseRestaurantVacancyPopup}
        />
        <MembershipPopupContainer
          key={"membershipPopup"}
          state={this.props.state}
          setPopupMode={this.props.setPopupMode}
          setPopupMessage={this.props.setPopupMessage}
          onClickClosePopupWindow={this.props.onClickClosePopupWindow}
          setDisplaySwitchTab={this.props.setDisplaySwitchTab}
          setSelectRecommendFlg={this.props.setSelectRecommendFlg}
          onClickCountWindow={this.props.onClickCountWindow}
        />
        <MembershipCrawlSearchContainer
          state={this.props.state}
          onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
          onClickOpenSavedSearchCriteriaWindow={this.props.onClickOpenSavedSearchCriteriaWindow}
          onClickOpenCheckListWindow={this.props.onClickOpenCheckListWindow}
          onClickOpenCrawlWindow={this.props.onClickOpenCrawlWindow}
          onClickOpenFacilityCalendarWindow={this.props.onClickOpenFacilityCalendarWindow}
          onClickOpenRoomDetailPopup={this.props.onClickOpenRoomDetailPopup}
          onClickOpenRestaurantVacancyPopup={this.props.onClickOpenRestaurantVacancyPopup}
          setVacancyInfo={this.props.setVacancyInfo}
          setSearchVacancyParam={this.props.setSearchVacancyParam}
        />
        <MembershipReservationPopupContainer
            state={this.props.state}
            onClickClosePopupWindow={this.props.onClickCloseReservationConfPopupWindow}
            onClickOpenCancelPopupWindow={this.props.onClickOpenCancelPopupWindow}
        />
        <MembershipCancelPopup
            state={this.props.state}
            onClickCloseCancelPopupWindow={this.props.onClickCloseCancelPopupWindow}
        />
        <MembershipFooterContainer />
      </>
    )
  }
}
export default MembershipCrawlSearchTemplate;
